import React, { useState, useEffect, useMemo } from "react";

// bootrap
import { Table, Modal, InputGroup, Form } from "react-bootstrap";
import moment from "moment";
import EmptyComponent from "../../components/EmptyComponent";
import AnimationLoading from "../../components/Animationloading";
import { LINEAR_GRADIENT_BG } from "../../const";
import SearchIcon from "@mui/icons-material/Search";

// import context from "react-bootstrap/esm/AccordionContext";
import { useLazyQuery } from "@apollo/client";
import { GET_SUVIVALS } from "../../apollo/unit/Query";
import { GET_PURCHASE_ORDER_DETAIL } from "../../apollo/purchaseOrderDetail/query";
import { FormatNumber } from "../../helper";

export default function PurchaseOrderHistory() {
  const [getPurchaseOrderDetail, { data: purchaseOrderDetailData, loading }] = useLazyQuery(GET_PURCHASE_ORDER_DETAIL, { fetchPolicy: "cache-and-network"});
  const [getSurvival, { loading: loadingSurvival, data: survivalData }] = useLazyQuery(GET_SUVIVALS, { fetchPolicy: "cache-first" });
  const [showDetailOrderhistory, setShowDetailOrderHistory] = useState(false);
  const [seletctOrderDetail, setSelectOrderDetail] = useState();
  const [searchText, setSearchText] = useState("");
  const [searchLot, setSearchLot] = useState("ALL");
  const [searchStatus, setSearchStatus] = useState("ALL");
  
  // Memoized values
  const lots = useMemo(() => {
    if (survivalData?.survivals?.data){
      return survivalData?.survivals?.data || [];
    }
    return [];
  }, [survivalData]);
  
  const purchaseOrderDetailHistory = useMemo(() => {
    if (purchaseOrderDetailData?.purchaseorderdetails?.data){
      return purchaseOrderDetailData?.purchaseorderdetails?.data || [];
    }
    return [];
  }, [purchaseOrderDetailData]);

  // Fetch data on component mount
  useEffect(() => {
    const controller = new AbortController();
    const fetchData = async () => {
      try {
        // Fetch both data in parallel using Promise.all
        await Promise.all([
          handleFetch(controller.signal),
          handleLot(controller.signal)
        ]);
      } catch (error) {
        if (!error.name === 'AbortError') {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, []);

  // Update data when search filters change
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (signal.aborted) return;
    if (searchText || searchLot || searchStatus) {
      handleFetch(signal);
    }
  }, [searchText, searchLot, searchStatus]);

  // Fetch purchase order details based on filters
  async function handleFetch(signal) {
    try {
      if (!signal.aborted) {
        if (loading) return;
        const userData = localStorage.getItem("SHOP_DATA");
        const locals = JSON.parse(userData);
        if (!locals) return;
        
        let where = {
          shop: locals?.id
        };
        
        // Handle status filtering
        if (searchStatus === "COMPLETED"){
          where.status = searchStatus;
          where.isSale = true;
        } else if (searchStatus !== "ALL") {
          where.status = searchStatus;
          where.isSale = false;
        }
        
        // Add lot and text search filters
        if (searchLot !== "ALL") where = {...where, lot: searchLot};
        if (searchText !== "") where = {...where, search: searchText};
        
        await getPurchaseOrderDetail({
          variables: {
            orderBy: "createdAt_DESC",
            where
          },
          context: {fetchOptions: { signal }},
        });
      };
    } catch (error) {
      console.log("Error in handleFetch:", error);
    }
  }

  // Fetch lot data
  async function handleLot(signal) {
    try {
      if (!signal.aborted) {
        if (loadingSurvival) return;
        const userData = localStorage.getItem("SHOP_DATA");
        const locals = JSON.parse(userData);
        if (!locals) return;
        
        await getSurvival({
          variables: {
            where: {
              shop: locals?.id || "",
              status: true,
              isDeleted: false
            },
          },
          context: {fetchOptions: { signal }},
        });
      };
    } catch (error) {
      console.log("Error in handleLot:", error);
    }
  }


  // map status
  const mapStatus = (status) => {
    switch (status) {
      case "PENDING":
        return <span style={{ color: "#3C169B" }}>ລໍຖ້າກວດສອບ</span>;
      case "COMPLETED":
        return <span style={{ color: "#28a745" }}>ອະນຸມັດແລ້ວ</span>;
      case "CANCELLED":
        return <span style={{ color: "#dc3545" }}>ປະຕິເສດ</span>;
      default:
        return <span>{status}</span>;
    }
  };

  if (loading) return <AnimationLoading />;
  
  return (
    <div className="purchaseorderhistory-main">
      <div className="purchaseorderhistory-header" style={{ marginTop: "1em", display: "flex" }}>
        <div style={{ width: "50%" }}>
          <InputGroup>
            <InputGroup.Text
              style={{
                backgroundColor: "#FFFFFF",
              }}>
              <SearchIcon sx={{ color: "#6B7280" }} />
            </InputGroup.Text>
            <Form.Control
              placeholder="ຄົ້ນຫາສິນຄ້າ..."
              aria-describedby="basic-addon2"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              value={searchText}
              style={{
                borderLeft: "none",
              }}
            />
          </InputGroup>
        </div>
        <div style={{ width: "25%", paddingLeft: "10px" }}>
          <Form.Select
            style={{
              height: "40px",
              color: "#6B7280",
              cursor: "pointer",
            }}
            onChange={(e) => {
              setSearchLot(e.target.value);
            }}
            value={searchLot}>
            {loadingSurvival ? (
              <option>Loading...</option>
            ): (
              <>
                <option value="ALL">ລ໊ອດທັງໝົດ</option>
                {lots?.map((lot) => (
                  <option key={lot.id} value={lot?.id}>
                    {lot?.survivalNumber}
                  </option>
                ))}
              </>
            )}
          </Form.Select>
        </div>
        <div style={{ width: "25%", paddingLeft: "10px" }}>
          <Form.Select
            style={{
              height: "40px",
              color: "#6B7280",
              cursor: "pointer",
            }}
            onChange={(e) => {
              setSearchStatus(e.target.value);
            }}
            value={searchStatus}>
            <option value="PENDING">ລໍຖ້າກວດສອບ</option>
            <option value="COMPLETED">ອະນຸມັດແລ້ວ</option>
            <option value="CANCELLED">ປະຕິເສດ</option>
            <option value="ALL">ທັງໝົດ</option>
          </Form.Select>
        </div>
      </div>
      <p style={{ color: "#6c757d", fontSize: "0.9rem", marginTop: "20px" }}>
        * ກົດທີ່ລາຍການເພື່ອເບິ່ງລາຍລະອຽດ
      </p>
      <div className="purchaseorderhistory-content">
        {purchaseOrderDetailHistory?.length > 0 ? (
          <Table
            style={{
              // marginTop: "5px",
              borderCollapse: "collapse",
              width: "100% ",
              background:'#fff'
            }}>
            <thead
              style={{
                background: LINEAR_GRADIENT_BG,
                borderRadius: " 8px 8px 0px 0px",
                color: "#FFFFFF",
              }}>
              <tr>
                <th>ລຳດັບ</th>
                <th>ລ໊ອດ</th>
                <th>ເລກທີບິນ</th>
                <th>ຈຳນວນສິນຄ້າທີ່ນຳເຂົ້າໃໝ່</th>
                <th>ວັນທີ, ເດືອນ, ປີ</th>
                <th>ສະຖານະ</th>
              </tr>
            </thead>
            <tbody>
              {purchaseOrderDetailHistory?.map((purchaseHistory, index) => (
                <tr
                  key={index}
                  style={{
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowDetailOrderHistory(true);
                    setSelectOrderDetail(purchaseHistory);
                  }}>
                  <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                  <td style={{ paddingTop: "1rem" }}>{purchaseHistory?.lot?.survivalNumber || "-"}</td>
                  <td style={{ paddingTop: "1rem" }}>
                    {purchaseHistory?.code}
                  </td>
                  <td
                    style={{
                      paddingTop: "1rem",
                      fontSize: "20px",
                      color: "green",
                      fontWeight: "bold",
                    }}>
                    + {purchaseHistory?.amount}
                  </td>
                  <td style={{ paddingTop: "1rem" }}>
                    {moment(purchaseHistory?.createdAt).format("DD/MM/YYYY")}
                  </td>
                  <td style={{ paddingTop: "1rem" }}>
                    {mapStatus(purchaseHistory?.status)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>
            {purchaseOrderDetailHistory?.length <= 0 && (
              <div
                style={{
                  fontSize: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#6B7280",
                  fontWeight: "400",
                }}>
                <EmptyComponent />
                <p>ຍັງບໍ່ມີປະຫວັດການສັ່ງຊື້ສິນຄ້າ !!!</p>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal
        size="xl"
        show={showDetailOrderhistory}
        onHide={() => setShowDetailOrderHistory(false)}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>ເລກທີບິນ : {seletctOrderDetail?.code} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ fontSize: "20px" }}>ລາຍການສິນຄ້າ</div>
          <div>
            <Table
              style={{
                marginTop: "20px",
                borderCollapse: "collapse",
                width: "100% ",
              }}>
              <thead
                style={{
                  background:
                    "#1F3A60",
                  borderRadius: " 8px 8px 0px 0px",
                  color: "#FFFFFF",
                }}>
                <tr>
                  <th>ລ/ດ</th>
                  <th>ຊື່ສິນຄ້າ</th>
                  <th>ປະເພດ</th>
                  <th>ຈຳນວນ</th>
                  <th>ສະກຸນເງິນ</th>
                  {seletctOrderDetail?.currency === "BAHT" || seletctOrderDetail?.currency === "USD" ? (
                    <th>ອັດຕາແລກປ່ຽນ</th>
                  ) : null}
                  <th>ຈຳນວນເງິນ</th>
                  <th>ເປັນເງິນກີບ</th>
                  <th>ວັນທີເດືອນປີ</th>
                  {/* <th>ຈັດການ</th> */}
                </tr>
              </thead>
              <tbody>
                {seletctOrderDetail?.purchaseorders?.map(
                  (purchaseHistory, index) => (
                    <tr
                      key={index}
                      style={{
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                      }}>
                      <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                      <td style={{ paddingTop: "1rem" }}>
                        {purchaseHistory?.productName}
                      </td>
                      <td style={{ paddingTop: "1rem" }}>
                        {purchaseHistory?.Category}
                      </td>
                      <td
                        style={{
                          paddingTop: "1rem",
                          fontSize: "20px",
                          color: "green",
                          fontWeight: "bold",
                        }}>
                        + {purchaseHistory?.amount}
                      </td>
                      <td style={{ paddingTop: "1rem" }}>
                        {purchaseHistory?.currency}
                      </td>
                      {seletctOrderDetail?.currency === "BAHT" ? (
                        <td style={{ paddingTop: "1rem" }}>
                          {seletctOrderDetail?.rateBaht}
                        </td>
                      ) : seletctOrderDetail?.currency === "USD" ? (
                        <td style={{ paddingTop: "1rem" }}>
                          {seletctOrderDetail?.rateUsd}
                        </td>
                      ) : null}
                      <td style={{ paddingTop: "1rem" }}>
                        {seletctOrderDetail?.currency==="BAHT"?"฿":
                        seletctOrderDetail?.currency==="USD"?"$":"₭"} {FormatNumber(purchaseHistory?.totalPrice)}
                      </td>
                      <td style={{ paddingTop: "1rem" }}>
                        {FormatNumber(seletctOrderDetail?.sumPrice)} ກີບ
                      </td>
                      <td style={{ paddingTop: "1rem" }}>
                        {moment(purchaseHistory?.createdAt).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailOrderHistory(false)}>
            Close
          </Button>
          <Button variant="primary">
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}
